import React, { useEffect, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import "./RouteFallback.scss";

/** Spinner shown while a lazy route chunk loads; delayed so fast loads don't flash. */
export const ROUTE_FALLBACK_DELAY_MS = 200;

const RouteFallback: React.FC = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => setVisible(true), ROUTE_FALLBACK_DELAY_MS);
		return () => clearTimeout(timer);
	}, []);

	if (!visible) {
		return null;
	}

	return (
		<div className="route-fallback" role="status" aria-live="polite" aria-busy="true">
			<ProgressSpinner className="route-fallback__spinner" strokeWidth="4" />
		</div>
	);
};

export default RouteFallback;
